import { Component, ElementRef, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IBlog } from 'src/app/shared/models/Iblog';
import { BlogService } from 'src/app/shared/services/blog.service';
import { TestimonialService } from 'src/app/shared/services/testimonial.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit {
  listBlogs: IBlog[];
  listTestimonios: any[];
  adap :boolean = true;
  @ViewChildren('testimonial') testimonialsRef!: QueryList<ElementRef>;
  maxTestimonialHeight: string = "";
  heightSlider: number = 300;
  constructor(private sanitizer: DomSanitizer,
    private _blogService: BlogService, private _testimoniales: TestimonialService) {
  }

  setAltura = ()=>{
    let maxHeight = 0;
      let maxElement: any | null = null;
      const domAll = document.querySelectorAll(".testimonial");
      if(domAll){
        domAll.forEach((testimonial: any) => {
          const height = testimonial.offsetHeight;
          console.log(height)
          if (height > maxHeight) {
            maxHeight = height;
            maxElement = testimonial;
          }
        });
      }
      const domCarousel: any = document.querySelector(".is-myc");
      if(domCarousel){
        console.log(maxElement)
        console.log(maxElement.offsetHeight)
        console.log(maxElement.getBoundingClientRect().height)
        console.log(maxHeight)
        domCarousel.style.height = `${(maxHeight + 20)}px`;
      }
  }
  slidesToShow = window.innerWidth< 768 ? 1 : 1;
  ngAfterViewInit(): void {
    requestAnimationFrame(() => {
      console.log('El DOM está completamente renderizado y pintado en pantalla',document.querySelectorAll(".testimonial"));
      setTimeout(() => {
          this.setAltura(); 
        }, 1000);               
    });
  }
  ngOnInit(): void {
    this._blogService.getBlogs().subscribe((data: IBlog[]) => {
      this.listBlogs = data;
    }, error => {
      console.error('Error fetching blogs:', error);
    });
    this._testimoniales.getData().subscribe(
      (data: any[]) => {
        this.listTestimonios = data;           
      },
      error => {
        console.error('Error fetching testimoniales:', error);
      }
    );
    
  }

}
